import { render, staticRenderFns } from "./SbppsStudentBulkIcardPrint.vue?vue&type=template&id=21e508de&scoped=true&"
import script from "./SbppsStudentBulkIcardPrint.vue?vue&type=script&lang=js&"
export * from "./SbppsStudentBulkIcardPrint.vue?vue&type=script&lang=js&"
import style0 from "./SbppsStudentBulkIcardPrint.vue?vue&type=style&index=0&id=21e508de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e508de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VImg,VRow,VSnackbar})
